module.exports = __webpack_public_path__ + "static/media/light-icon-success.84837fd8.png";